module.exports = __webpack_public_path__ + "static/HUIPUT_slogan_FI-03-185725f73de71bd2ef925cc390e4e56c.svg";